// extracted by mini-css-extract-plugin
module.exports = {"infoMessage":"_765512b"};